module.exports = __webpack_public_path__ + "static/media/energy_card_green.843271e0.svg";